export const iconFontAwesomeMapsFire = (
	<i className="fa-solid fa-fire"></i>
);
